/**
 * `/connect/slack/install/:chatAppId` — the install link of a genie's own Slack app.
 * Public: the link stays the same when the owner replaces their credentials, so
 * Slack's authorize page is looked up on each visit.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Loader2 } from "lucide-react";
import { chatChannelService } from "@/services/agent/ChatChannelService";

const BRAND_GRADIENT = "linear-gradient(135deg, #4E9CFF, #FF4DB8)";

export const SlackOwnAppInstall = () => {
  const { chatAppId } = useParams<{ chatAppId: string }>();
  const [hasFailed, setHasFailed] = useState(!chatAppId);

  useEffect(() => {
    if (!chatAppId) return;
    chatChannelService
      .getOwnAppInstallUrl(chatAppId)
      .then((url) => window.location.replace(url))
      .catch(() => setHasFailed(true));
  }, [chatAppId]);

  return (
    <div
      className="min-h-[100dvh] flex flex-col items-center justify-center text-center px-6"
      style={{ background: BRAND_GRADIENT }}
    >
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>Add to Slack</title>
      </Helmet>

      {hasFailed ? (
        <>
          <h1 className="text-white text-2xl font-bold">This install link isn&rsquo;t available</h1>
          <p className="text-white/85 text-sm mt-2 max-w-sm">Ask whoever sent it to you for a new one.</p>
        </>
      ) : (
        <>
          <Loader2 className="w-10 h-10 text-white animate-spin mb-5" />
          <h1 className="text-white text-xl font-semibold">Opening Slack&hellip;</h1>
        </>
      )}
    </div>
  );
};

export default SlackOwnAppInstall;
